import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as userDataActions from '../../../actions/userDataActions';
import * as dialogPopupActions from '../../../actions/dialogPopupActions';
import * as appHelper from '../../../helpers/appHelper';
import * as dataHelper from '../../../helpers/dataHelper';
import * as userDataHelper from '../../../helpers/userDataHelper';
import * as objectConstants from '../../../constants/objectConstants';
import {ASSET_CONFIG} from '../../../models/dialogModels';
import {getChildObjectComponentByType} from "../../../helpers/componentHelper";
import * as keyboardConstants from '../../../constants/keyboardConstants';

class ResourceVideoLink extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            resource: this.props.resource,
            userData: this.props.userData,
            locale: appHelper.getLocalData(this.props.resource),
            videoType:{},
            video: {
                src: "",
            },
            setVideoType: false,
            required_label: appHelper.getLocaleString("required_label")
        };
        this.onOpen = this.onOpen.bind(this);
        this.getStatusClass = this.getStatusClass.bind(this);
        this.updateResourceObjectResult = this.updateResourceObjectResult.bind(this);
        this.getAssets = this.getAssets.bind(this);
        this.onCloseVideoDialog = this.onCloseVideoDialog.bind(this);
        this.launchVideo = this.launchVideo.bind(this);
        this.setKeyboardAccessibility = this.setKeyboardAccessibility.bind(this);

    }

    componentDidMount() {
        this.getAssets();
    }

    componentWillReceiveProps(nextProps) {
        if(this.state.userData !== nextProps.userData){
            this.setState({userData: Object.assign({}, nextProps.userData)});
        }
        if(this.state.lang !== nextProps.lang){
            let video = appHelper.getLocalData(video);
            let videoType = Object.assign({}, getChildObjectComponentByType(`${video.sub_type}`));
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.resource),
                video: appHelper.isDefined(video) && video.src.length > 0 ? video : this.state.video,
                videoType: appHelper.isDefined(video) && video.src.length > 0 ? videoType : this.state.videoType,
                required_label: appHelper.getLocaleString("required_label")
            });
        }
    }

    componentDidUpdate() {
        if(this.state.setVideoType){
            this.getVideoType();
        }
    }


    getAssets() {
        let video = appHelper.getVideoAsset(this.state.resource);
        video = appHelper.getLocalData(video);
        let videoType = Object.assign({}, getChildObjectComponentByType(`${video.sub_type}`));
        if (appHelper.isDefined(video) && video.src.length > 0) {
            this.setState({
                video: video,
                videoType: videoType
            });
        }
    }

    onCloseVideoDialog(viewed){
        let objectUserData = userDataHelper.getAttachmentObjectUserData(this.state.userData, this.state.resource.screen_id, this.state.resource.asset_id);
        if(objectUserData.status !== objectConstants.STATUS_COMPLETE && viewed) {
            this.updateResourceObjectResult();
        }
    }

    launchVideo(){
        let childComponenents = [];
        let config = Object.assign({}, ASSET_CONFIG,
            {
                title: this.state.locale.label,
                onClose: this.onCloseVideoDialog,
                showCloseBtn: false,
                theme: "dialog-asset-image",
                sourceId: `resource_link_${this.state.resource.screen_id}`
            }
        );

        for (let i = 0; i < config.childComponents.length; i++) {
            let child = config.childComponents[i];
            child = Object.assign({},child,{
                childComponent: this.state.videoType.component,
                componentProps: Object.assign({}, {
                    screenObject: this.state.resource,
                    callbacks:{},
                    video: this.state.video
                })
            });

            childComponenents = dataHelper.immutablePush(childComponenents, child);
        }
        config = Object.assign({},config,{
            childComponents: childComponenents
        });

        this.props.actions.setNewAssetDialog(config);
    }


    getStatusClass(){
        let objectUserData = userDataHelper.getAttachmentObjectUserData(this.state.userData, this.state.resource.asset_id);

        if (objectUserData.status === objectConstants.STATUS_NOT_STARTED) {
            return "not-started";
        } else if (objectUserData.status === objectConstants.STATUS_IN_PROGRESS) {
            return "in-progress";
        } else if (objectUserData.status === objectConstants.STATUS_COMPLETE) {
            return "complete";
        }
    }

    onOpen(){
        this.launchVideo();
    }

    updateResourceObjectResult(){
        let params ={
            asset_id: this.state.resource.asset_id,
            asset_type_code: this.state.resource.object_type,
            status: objectConstants.STATUS_COMPLETE,
        };

        this.props.actions.updateResourceObjectResult(params).then((userData) => {
            this.props.actions.setSuspendData(userData).then((trackingData) => {}).catch(error => {});
        }).catch(error => {
        });
    }

    setKeyboardAccessibility(event) {
        if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
            event.preventDefault();
            this.onOpen();
        }
    }

    render() {
        return (
            <li className={`resource-link ${this.getStatusClass()}`}>
                <span className="video" onClick={this.onOpen} onKeyDown={this.setKeyboardAccessibility} role="link" tabIndex="0"  id={`resource_link_${this.state.resource.screen_id}`} dangerouslySetInnerHTML={{__html: this.state.locale.label}} />
                {this.state.resource.required
                    ?
                    <span className="required-label"> - {this.state.required_label}</span>
                    :
                    null
                }
            </li>
        );
    }
}

ResourceVideoLink.propTypes = {
    resource: PropTypes.object.isRequired,
    trackingData: PropTypes.object.isRequired,
    userData: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    actions: PropTypes.object.isRequired
};

ResourceVideoLink.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang:lang,
        contentData: state.contentData,
        trackingData: state.trackingData,
        userData: state.userData
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, userDataActions,dialogPopupActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ResourceVideoLink);



/** WEBPACK FOOTER **
 ** ./src/components/objects/resourceLinks/ResourceVideoLink.js
 **/